"use client";

export function VerifiedBadge({ size = "sm" }: { size?: "sm" | "md" }) {
  const isMd = size === "md";
  return (
    <span
      className={`inline-flex items-center gap-1 shrink-0 ${
        isMd
          ? "px-2.5 py-0.5 rounded-full bg-[#E8F4FD] text-[#1565C0] text-[12px] font-semibold"
          : "px-2 py-0.5 rounded-full bg-[#E8F4FD] text-[#1565C0] text-[11px] font-semibold"
      }`}
      title="Verified employer"
    >
      <svg
        width={isMd ? "14" : "12"}
        height={isMd ? "14" : "12"}
        viewBox="0 0 24 24"
        fill="#1565C0"
      >
        <path d="M12 1l3.09 4.26L20 6.27l-2.18 4.32L18.18 16 12 14.14 5.82 16l.36-5.41L4 6.27l4.91-1.01L12 1z" />
        <path
          d="M10 14.2l-2.5-2.5 1.41-1.41L10 11.38l4.09-4.09 1.41 1.41L10 14.2z"
          fill="white"
        />
      </svg>
      Verified
    </span>
  );
}
